var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#050506",
    strokeWidth: 1.5,
    d: "M11 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#050506",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M3.5 19c1.421-2.974 4.247-5 7.5-5s6.079 2.026 7.5 5"
  })));
};
export default SvgUser;